import type { StyleSystemProps } from '@withjoy/joykit';
import { styled, TextV1 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

// cannot find matching joykit text variant
export const StyledText = styled(TextV1)`
  font-family: 'Inter UI';
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
  letter-spacing: -0.01em;
  text-align: left;

  @media (min-width: 640px) {
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: -0.015em;
    text-align: center;
  }
`;

const skeletonContainerStyles: StyleSystemProps = {
  width: pxToRem(860),
  marginX: 'auto',
};

const skeletonPaneContainerStyles: StyleSystemProps = {
  width: '100%',
  alignItems: 'center',
  maxWidth: '100%',
  marginX: 'auto',
  marginTop: 8,
  paddingTop: 8,
  position: 'relative',

  _before: {
    position: 'absolute',
    content: '" "',
    height: '1px',
    width: '100%',
    top: 0,
    boxShadow: 'rgb(235 235 235) 0px -2px 0px 0px',
  },
};

export const styles = {
  skeletonContainer: skeletonContainerStyles,
  skeletonPaneContainer: skeletonPaneContainerStyles,
};
